import { BETA, DEVELOPMENT, PRODUCTION, STAGING } from './consts';

export const ALL_ENVIRONMENT = 'all';

export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';
export const isTest = process.env.NODE_ENV === 'test';

const betaRegExp = /https:\/\/[a-zA-Z0-9_-]+\.cyberint\.io\/beta/;
const stgRegExp = /https:\/\/[a-zA-Z0-9_-]+\.staging\.cyberint\.io/;
// const localRegExp = /https*:\/\/localhost:[0-9]+/;

export const getEnvironmentType = () => {
  if (process.env.NODE_ENV === PRODUCTION) {
    if (window.location.href.match(stgRegExp)) return STAGING;
    if (window.location.href.match(betaRegExp)) return BETA;
    return PRODUCTION;
  }

  return DEVELOPMENT;
};

export const isBeta = getEnvironmentType() === BETA;

export const isNotProd = getEnvironmentType() !== PRODUCTION;
